import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="font-heading text-sm text-primary-600">动漫网漫画分类大全</span>
            <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-4xl">分类大全 · 一站配齐</h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600 md:text-base">
              从国漫到日漫，从热血到治愈，点选任一分类即可快速浏览对应动漫列表。
            </p>
          </div>
          <Link
            to="/categories"
            className="inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-background-300 px-5 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            进入全部动漫
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/categories?cat=${cat.slug}`}
              className="group relative block aspect-[4/5] overflow-hidden rounded-lg"
              aria-label={`进入 ${cat.name} 分类`}
            >
              <img
                src={cat.cover}
                alt={`${cat.name} 动漫分类`}
                title={`${cat.name} 分类`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/10 to-transparent"></div>
              <div className="absolute inset-x-0 bottom-0 p-3 md:p-4">
                <h3 className="font-heading text-lg text-background-50 md:text-xl">{cat.name}</h3>
                <p className="mt-1 line-clamp-1 text-xs text-background-50/80">{cat.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}